import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RecordFormPageRoutingModule } from './record-form-routing.module';
import { MaterialModule } from '../material.module';

import { QuillModule } from 'ngx-quill';

import { RecordFormPage } from './record-form.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    QuillModule.forRoot(),
    MaterialModule,
    RecordFormPageRoutingModule
  ],
  declarations: [RecordFormPage]
})
export class RecordFormPageModule {}
